export function isEmpty<T>(obj: T) {
  if (obj) return Boolean(Object.keys(obj)?.length === 0);
}
